(function ($, Drupal) {

  // Support page dynamics.
  Drupal.behaviors.support = {
    attach: function (context, settings) {

      $('.support', context).once('support').each(function () {

        let $el = $(this),
          $helper = $el.find('.support__helper'),
          $resPixel = $('.js_resolution');


        $helper.on('click', function (evt) {

          evt.preventDefault();

          let $this = $(this);

          if ($this.hasClass('is_active')) {
            $this.removeClass('is_active');
            $('body').removeClass('body_lock');
          }
          else {
            $helper.removeClass('is_active');
            $this.addClass('is_active');
          }

          lockBody();
        });

        function lockBody() {
          if ($helper.hasClass('is_active') && ($resPixel.css('opacity') < '0.5')) {
            $('body').addClass('body_lock');
          }
        }

        lockBody();




      });

    }
  };

})(jQuery, Drupal);